import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RelativeDatePipe } from '@app/pipes/relative-date.pipe';
import { Store } from '@ngrx/store';
import { _, TranslatePipe } from '@ngx-translate/core';
import type { AppState } from '@reducers/interfaces';
import { selectCanViewEmployeeProfile } from '@reducers/orm/permission/permission.selectors';
import { BadgeComponent } from '@sb/ui/badge';

import { DecisionListWidgetComponent } from '../decision-list-widget/decision-list-widget.component';
import { useDecisionList } from '../decision-list-widget/use-decision-list';
import { toDocumentReviewRow } from './document-review-row';
import { DocumentReviewsApiService } from './document-reviews-api.service';

@Component({
  selector: 'files-to-review-widget',
  templateUrl: './files-to-review-widget.component.html',
  imports: [DecisionListWidgetComponent, TranslatePipe, RelativeDatePipe, RouterLink, BadgeComponent],
})
export class FilesToReviewWidgetComponent {
  #api = inject(DocumentReviewsApiService);

  #canViewEmployeeProfile = inject<Store<AppState>>(Store).selectSignal(selectCanViewEmployeeProfile);

  list = useDecisionList({
    load: () => this.#api.list(),
    toRows: (filesToReview) =>
      filesToReview.rows.map((file) => toDocumentReviewRow(file, this.#canViewEmployeeProfile())),
  });

  badgeLabel = computed(() => (this.list.count() ? _('[count] pending review') : _('None pending review')));
}
